module.exports = __webpack_public_path__ + "img/bvi_3.bcf41566.png";